module.exports = __webpack_public_path__ + "img/bg-dashboard-orange.d5a128dc.png";